import kiosk from './kiosk';
import permits from "./permits";
import terminals from "./terminals";

export default {
  namespaced: true,
  modules: {
    kiosk,
    permits,
    terminals
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/kiosks/index.js